import React, { useState, useRef } from "react";
import { Form, Col, Row } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../../components/Button";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";

const UpdateIndexPhotos = () => {
  const { access } = useIsAdmin();
  document.title = "LVF1 - Update Index Photos";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const refMain = useRef<any>(null);
  const refSecondary = useRef<any>(null);
  const [pictureMain, setPictureMain] = useState();
  const [pictureSecondary, setPictureSecondary] = useState();
  const [validated, setValidated] = useState(false);
  const [uploading, setUploading] = useState(false);

  const submitForm = (event: any) => {
    if (token == null) return;
    /* REALOADS BECAUSE THE FOLDER OF THE PDFS IS INSIDE /PUBLIC ! */
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const formDataFiles = new FormData();
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);

    if (pictureMain != null) formDataFiles.append("pictureMain", pictureMain);
    if (pictureSecondary != null)
      formDataFiles.append("pictureSecondary", pictureSecondary);

    if (!(form !== null && form.checkValidity() === false)) {
      setUploading(true);
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/admin/updateIndexPhotos`,
          formDataFiles,
        )
        .then(() => {
          toast.success("Photos updated successfully");
          setUploading(false);
          setValidated(false);
        })
        .catch(({ response }) => {
          toast.error("Error updating photos");
          setUploading(false);
          setValidated(false);
          throw new Error(response);
        });
    }
    setValidated(true);
  };

  if (!access) return <ErrorPage />;
  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="Update Photos" />
        <small className="mandatory-fields">(*) Required fields</small>
        <Form noValidate validated={validated} onSubmit={submitForm}>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Main Championship</Form.Label>
              <Form.Control
                type="file"
                ref={refMain}
                accept=".jpg"
                onChange={() => setPictureMain(refMain.current.files[0])}
              />
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Secondary Championship Photo</Form.Label>
              <Form.Control
                type="file"
                ref={refSecondary}
                accept=".jpg"
                onChange={() =>
                  setPictureSecondary(refSecondary.current.files[0])
                }
              />
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-center">
            {uploading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button text={"Update Photos"} type="submit" />
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default UpdateIndexPhotos;
